import { IndexTable, InlineStack, SkeletonBodyText, SkeletonDisplayText } from '@shopify/polaris';
import React from 'react';

const ValueMappingSkelton = () => {
    const skeltonMarkup = [1, 2, 3, 4, 5, 6, 7, 8].map((ele, ind) => {
        return (
            <IndexTable.Row id={String(ele)} key={ele} position={ind}>
                <IndexTable.Cell className="value-mapping-table__item">
                    <InlineStack gap="200" blockAlign="center">
                        <div className="value-mapping-table__skelton-iconItem">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <div style={{ width: '100px' }}>
                            {' '}
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </IndexTable.Cell>
                <IndexTable.Cell className="value-mapping-table__item">
                    <InlineStack gap="200" blockAlign="center">
                        <div className="value-mapping-table__skelton-iconItem">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <div style={{ width: '100px' }}>
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </IndexTable.Cell>
                <IndexTable.Cell className="value-mapping-table__item">
                    <SkeletonDisplayText size="small" maxWidth={`${60}%`} />
                </IndexTable.Cell>
            </IndexTable.Row>
        );
    });
    return (
        <IndexTable
            key={'JSONValueMapping'}
            resourceName={{
                singular: 'attribute',
                plural: 'attributes',
            }}
            itemCount={4}
            headings={[
                {
                    title: 'Shopify attributes',
                    id: 'shopify_attribute',
                },
                {
                    title: 'Amazon  Attributes',
                    id: 'amazon_attribute',
                },
                { title: 'Action', id: 'action' },
            ]}
            selectable={false}>
            {skeltonMarkup}
        </IndexTable>
    );
};

export default ValueMappingSkelton;
